// polyfills
import '@quotient/riq-ie';
// npm deps
import React from 'react';
import ReactDOM from 'react-dom';
// local modules
import App from './App';
import './styles/index.css';
import './styles/bootstrap.scss';

import * as serviceWorker from './serviceWorker';

if (window.cdnBasePath) {
  __webpack_public_path__ = window.cdnBasePath;
}

ReactDOM.hydrate(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
module.hot && module.hot.accept();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
